export enum CategoriesFundEnum {
    Print = 1,
    PC = 2,
    Both = 3,
}